export const selectedLoader = (state: any) => {
  return state.get('loaders');
};
